import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import find from 'lodash/find';
import { Dropdown } from 'react-bootstrap';
import { SharedMessages as sharedMessages } from 'ecs-react-components/dist/index.es';
import {
  languageChange,
  putPreferredLanguageByPatient,
  putPreferredLanguage,
} from '../../redux/modules/language/language-middleware';
import { loadSupportedLanguages } from '../../redux/modules/capability/capability-middleware';

class LanguageSelectionDropdown extends React.Component {
  UNSAFE_componentWillMount() {
    this.props.dispatch(loadSupportedLanguages());
  }

  handleLanguageSelect = (lang) => () => {
    const {
      dispatch,
      patientId,
      userId,
      isAuthRep,
    } = this.props;

    if (lang) {
      if (isAuthRep) {
        dispatch(putPreferredLanguage(userId, lang));
      } else if (patientId) {
        dispatch(putPreferredLanguageByPatient(patientId, lang));
      } else {
        dispatch(languageChange(lang));
      }
    }
  }

  languageText(lang) {
    return <FormattedMessage {...lang} />;
  }

  render() {
    const {
      intl: {
        formatMessage,
      },
      supportedLanguages,
      language: {
        languageCode,
      },
      selectId,
      inMenu,
      visibilityClass,
    } = this.props;

    if (!supportedLanguages || !supportedLanguages.length) {
      return null;
    }

    const currentLanguage = find(supportedLanguages, { languageCode }) || supportedLanguages[0];

    const ariaLabel = formatMessage(sharedMessages.dropdown.languageSelected) + ' ' +
      currentLanguage.displayName;
    const currentLanguageDisplay = currentLanguage.displayName || '';
    const dropDownId = selectId || 'languageDropdown';
    return (
      inMenu ?
        <Dropdown id={dropDownId} className={visibilityClass} as="li"
          aria-label={ariaLabel}
        >
          <Dropdown.Toggle className="nav-link" as="a" role="button">
           <span className="fa-solid fa-globe" aria-hidden="true" />
          </Dropdown.Toggle>
          <Dropdown.Menu as="ul">
          {
            supportedLanguages.map((lang) =>
              (
                <Dropdown.Item as="li"
                  key={lang.languageCode}
                  onClick={this.handleLanguageSelect(lang.languageCode)}
                >
                  {lang.displayName}
                </Dropdown.Item>
              ))
          }
          </Dropdown.Menu>
        </Dropdown> :
        <Dropdown id={dropDownId}>
          <Dropdown.Toggle className="btn-primary top-right-utility-buttons mb-3">
            <span className="fa-solid fa-globe" aria-hidden="true" >&nbsp;</span>
            {currentLanguageDisplay}
          </Dropdown.Toggle>
          <Dropdown.Menu aria-label={ariaLabel}>
            {
              supportedLanguages.map((lang) =>
                (
                  <Dropdown.Item key={lang.languageCode} onClick={this.handleLanguageSelect(lang.languageCode)}>
                    {lang.displayName}
                  </Dropdown.Item>
                )
              )
            }
          </Dropdown.Menu>
        </Dropdown>
    );
  }
}

LanguageSelectionDropdown.propTypes = {
  dispatch: PropTypes.func.isRequired,
  language: PropTypes.object.isRequired,
  supportedLanguages: PropTypes.array.isRequired,
  userId: PropTypes.string,
  selectId: PropTypes.string,
  intl: PropTypes.object,
  inMenu: PropTypes.bool,
  visibilityClass: PropTypes.string,
  patientId: PropTypes.string,
  isAuthRep: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  language: state.language,
  supportedLanguages: state.capability.languages,
  userId: state.profile.user.userId,
  patientId: state.profile.patient.patientId,
  isAuthRep: state.profile.user.isAuthorizedRepresentative,
});

export default connect(mapStateToProps)(injectIntl(LanguageSelectionDropdown));